import { useState } from "react";
import { X, Globe } from "lucide-react";
import { cn } from "@/lib/utils";

export function SmartGreetingBanner({ greeting, translation, followUp, valuesNote, onDismiss }) {
  const [expanded, setExpanded] = useState(false);

  if (!greeting) return null;

  return (
    <div
      data-testid="smart-greeting-card"
      className="px-4 pt-2 animate-in fade-in slide-in-from-top-2 duration-400"
    >
      <div className="max-w-2xl mx-auto relative group">
        <div
          className={cn(
            "flex items-start gap-3 rounded-xl border border-primary/12 bg-primary/[0.03] px-3.5 py-2.5 transition-all cursor-pointer",
            expanded && "rounded-b-none border-b-0"
          )}
          onClick={() => setExpanded(e => !e)}
        >
          {/* Icon */}
          <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0 mt-0.5">
            <Globe className="w-4 h-4 text-primary" strokeWidth={2} />
          </div>

          {/* Content */}
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold leading-snug">{greeting}</p>
            {translation && (
              <p className="text-xs text-muted-foreground mt-0.5 italic truncate">{translation}</p>
            )}
          </div>

          {/* Dismiss */}
          <button
            data-testid="smart-greeting-dismiss"
            onClick={(e) => { e.stopPropagation(); onDismiss?.(); }}
            className="p-1 rounded-md hover:bg-muted/60 transition-colors opacity-0 group-hover:opacity-100 flex-shrink-0"
            aria-label="Dismiss greeting"
          >
            <X className="w-3.5 h-3.5 text-muted-foreground" />
          </button>
        </div>

        {/* Expandable detail */}
        {expanded && (
          <div className="border border-t-0 border-primary/12 rounded-b-xl bg-primary/[0.02] px-3.5 pb-3 pt-1 animate-in fade-in slide-in-from-top-1 duration-200">
            {followUp && (
              <p className="text-xs text-foreground/70 leading-relaxed">{followUp}</p>
            )}
            {valuesNote && (
              <p className="text-[11px] text-muted-foreground/50 mt-2 leading-relaxed border-t border-primary/8 pt-2">
                {valuesNote}
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
